import { render, staticRenderFns } from "./TradeRequestInformationTable.vue?vue&type=template&id=88ddad78&scoped=true"
import script from "./TradeRequestInformationTable.vue?vue&type=script&lang=js"
export * from "./TradeRequestInformationTable.vue?vue&type=script&lang=js"
import style0 from "./TradeRequestInformationTable.vue?vue&type=style&index=0&id=88ddad78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ddad78",
  null
  
)

export default component.exports